import { render, staticRenderFns } from "./CashWithdrawFormOtp.vue?vue&type=template&id=2444e7dd&scoped=true"
import script from "./CashWithdrawFormOtp.vue?vue&type=script&lang=js"
export * from "./CashWithdrawFormOtp.vue?vue&type=script&lang=js"
import style0 from "./CashWithdrawFormOtp.vue?vue&type=style&index=0&id=2444e7dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444e7dd",
  null
  
)

export default component.exports